
export default {
	setCartItems(state, list)
	{
		var nextId = 0;
		var items = {};

		state.itemIds = list.map(it => {
			let id = nextId++;
			items[id] = { ...it, id };
			return id;
		});
		state.items = items;
	},

	setCartTotals(state, totals)
	{
		state.totals = { ...state.totals, ...totals };
	}
}